import { v4 as uuidv4 } from 'uuid'
interface Props {
  [key: string]: any
}

export default function HomReceiptIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  const uuid = uuidv4()
  return (
    <svg fill="none" viewBox="0 0 32 35" {...rest} xmlns="http://www.w3.org/2000/svg">
      <g filter={`url(#${uuid}filter0_d_279:9383)`}>
        <path
          d="M30 28.4047V3.03616C30 1.91623 28.8354 1 27.4123 1H4.5878C3.16452 1 2 1.91623 2 3.03616V28.4047C2 28.8695 2.25877 32.8431 2.25877 32.8431L5.16539 31.038L6.36671 32.675L7.59791 30.9973L8.79923 32.6342L10.0304 30.9565L11.2318 32.5935L12.463 30.9158L13.6643 32.5528L14.8955 30.8751L16.097 32.5123L17.3279 30.8343L18.5293 32.4716L19.7606 30.7936L20.9619 32.4308L22.1932 30.7528L23.3946 32.3901L24.6255 30.7121L25.8269 32.3493L27.0582 30.6714L30 32.3953C30 32.3953 30 28.7104 30 28.4047Z"
          fill={`url(#${uuid}paint0_linear_279:9383)`}
        />
      </g>
      <path
        d="M26.598 13.5119H5.95093C5.57102 13.5119 5.2627 13.3242 5.2627 13.0929V12.2549C5.2627 12.0236 5.57102 11.8359 5.95093 11.8359H26.598C26.9779 11.8359 27.2862 12.0236 27.2862 12.2549V13.0929C27.2862 13.3242 26.9779 13.5119 26.598 13.5119Z"
        fill="white"
      />
      <path
        d="M26.598 20.2156H5.95093C5.57102 20.2156 5.2627 20.0279 5.2627 19.7966V18.9587C5.2627 18.7274 5.57102 18.5397 5.95093 18.5397H26.598C26.9779 18.5397 27.2862 18.7274 27.2862 18.9587V19.7966C27.2862 20.0279 26.9779 20.2156 26.598 20.2156Z"
        fill="white"
      />
      <path
        d="M26.598 26.9195H5.95093C5.57102 26.9195 5.2627 26.7318 5.2627 26.5005V25.6625C5.2627 25.4312 5.57102 25.2435 5.95093 25.2435H26.598C26.9779 25.2435 27.2862 25.4312 27.2862 25.6625V26.5005C27.2862 26.7318 26.9779 26.9195 26.598 26.9195Z"
        fill="white"
      />
      <path
        d="M26.598 10.1599H5.95093C5.57102 10.1599 5.2627 9.87837 5.2627 9.53145V8.27448C5.2627 7.92756 5.57102 7.646 5.95093 7.646H26.598C26.9779 7.646 27.2862 7.92756 27.2862 8.27448V9.53145C27.2862 9.87837 26.9779 10.1599 26.598 10.1599Z"
        fill="white"
      />
      <path
        d="M26.598 16.8637H5.95093C5.57102 16.8637 5.2627 16.676 5.2627 16.4447V15.6067C5.2627 15.3755 5.57102 15.1877 5.95093 15.1877H26.598C26.9779 15.1877 27.2862 15.3755 27.2862 15.6067V16.4447C27.2862 16.676 26.9779 16.8637 26.598 16.8637Z"
        fill="white"
      />
      <path
        d="M26.598 23.5676H5.95093C5.57102 23.5676 5.2627 23.3798 5.2627 23.1486V22.3106C5.2627 22.0793 5.57102 21.8916 5.95093 21.8916H26.598C26.9779 21.8916 27.2862 22.0793 27.2862 22.3106V23.1486C27.2862 23.3798 26.9779 23.5676 26.598 23.5676Z"
        fill="white"
      />
      <defs>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="34.5357"
          id={`${uuid}filter0_d_279:9383`}
          width="30.6925"
          x="0.46142"
          y="0.23071"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dx="-0.192322" dy="0.576967" />
          <feGaussianBlur stdDeviation="0.673129" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend in2="BackgroundImageFix" mode="normal" result="effect1_dropShadow_279:9383" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_279:9383" mode="normal" result="shape" />
        </filter>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${uuid}paint0_linear_279:9383`}
          x1="16"
          x2="16"
          y1="32.8431"
          y2="1"
        >
          <stop stopColor="#9F7ED6" />
          <stop offset="1" stopColor="#833FD4" />
        </linearGradient>
      </defs>
    </svg>
  )
}
